/**
 * Number formatting utilities for display purposes.
 * These should only be used in JSX render — never on data used for sorting.
 */

// Format a number with comma separators: 1234567.89 → "1,234,567.89"
export function fmtNum(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) return value;
    var num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('en-US');
}

// Format a dollar amount with $ and commas, 2 decimals: 1234.5678 → "$1,234.57"
export function fmtDollar(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) return value;
    var num = Number(value);
    if (isNaN(num)) return value;
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Format a dollar amount with $ and commas, 4 decimals: 1234.5678 → "$1,234.5678"
export function fmtDollar4(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) return value;
    var num = Number(value);
    if (isNaN(num)) return value;
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
}

// Format minutes with commas, 1 decimal: 742085.3 → "742,085.3"
export function fmtMins(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) return value;
    var num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

// Format integer count with commas: 8351434 → "8,351,434"
export function fmtInt(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) return value;
    var num = Number(value);
    if (isNaN(num)) return value;
    return Math.round(num).toLocaleString('en-US');
}

// Format percentage — just pass through (already formatted as "20.82%")
export function fmtPct(value) {
    if (value === null || value === undefined || value === '') return 'N/A';
    return value;
}
